import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_CONFIG } from 'src/app/config/api.config';
import { UnidadeDTO } from 'src/app/models/curso/unidadeDTO';

@Injectable({
  providedIn: 'root'
})
export class UnidadeService {

  constructor(private http: HttpClient){ 
  }

  insert(unidadeDTO: UnidadeDTO) : Observable<any> {
    

    return this.http.post<any>( API_CONFIG.apiURL+'/unidades'
                              , unidadeDTO
                              , { observe: 'response' }); //.pipe(timeout(100000))

  }

  update(unidadeDTO: UnidadeDTO) : Observable<any> {
    
    return this.http.put<any>( API_CONFIG.apiURL+'/unidades/' + unidadeDTO.id
                             , unidadeDTO
                             , { observe: 'response' });

  }


  findAll() : Observable<UnidadeDTO[]> {

    return this.http.get<UnidadeDTO[]>( API_CONFIG.apiURL+'/unidades');

  }

  
  find(id: number) : Observable<UnidadeDTO> {

    return this.http.get<UnidadeDTO>( API_CONFIG.apiURL+'/unidades/' + id);

  }

  delete(id: number) : Observable<void> {

    return this.http.delete<void>( `${API_CONFIG.apiURL}${'/unidades/'}${id}`);

  }

  sortArray(unidades: UnidadeDTO[]){
  
    unidades.sort(function (a, b) {
      if (a.nome > b.nome) {
        return 1;
      }
      if (a.nome < b.nome) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
      
  }

}
